export default {
  lookup(name) {
    return `/assets/images/${name}`;
  },
};
